import React from "react";
import MuiAccordion from "@material-ui/core/Accordion/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {HearthIcon, ServicePosition} from "./CartItem";
import {
    action_catalog,
    apiURL,
    contractId,
    CORSSupport,
    userID,
    userLogin,
    userPassword
} from "../configurationConstant";
import {
    addItem,
    deleteItem,
} from "../store/actions/cart_actions";
import {connect} from "react-redux";
import {setVisiblePosition} from "../store/actions/catalog_actions";

export const QR = require('../images/QR.png');
export const code  = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H2V13H0V0Z" />
    <path d="M14 0H16V13H14V0Z" />
    <path d="M3 0H4V13H3V0Z" />
    <path d="M5 0H6V13H5V0Z" />
    <path d="M7 0H9V13H7V0Z" />
    <path d="M10 0H11V13H10V0Z" />
    <path d="M12 0H13V13H12V0Z" />
    <path d="M15 14H16V16H15V14Z" />
    <path d="M13 14H14V16H13V14Z" />
    <path d="M10 14H12V16H10V14Z" />
    <path d="M5 14H9V16H5V14Z" />
    <path d="M3 14H4V16H3V14Z" />
    <path d="M0 14H2V16H0V14Z" />
</svg>


class CatalogItem extends React.Component{
    constructor(props){
        super(props);
        this.getCatalogItem = this.getCatalogItem.bind(this);
        this.buttonChangeValue = this.buttonChangeValue.bind(this);
        this.clearItem = this.clearItem.bind(this);
        this.setServiceCount = this.setServiceCount.bind(this);
        this.setItem = this.setItem.bind(this);
        let count = 0;
        let service  = [];
        let refund = 0;
        this.props.cart.cart_items.map(element => {
            if (Number(element.id) === Number(this.props.id)){
                element.services.map(service =>{
                    count += service.count;
                });
                service = element.services;
                refund = element.refund
            }
        });
        this.state = {
            item: this.props.data,
            loaded: false,
            services: service,
            price: 0,
            refund: refund,
            count: count,
            id: this.props.id
        }
    }

    componentDidMount(){
        this.getCatalogItem(this.props.id)
    }

    getCatalogItem(item){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_catalog + '&contract=' + contractId + '&log='+userLogin+'&pwd='+userPassword+'&user=' + userID + '&catalog=' + item,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200)
                return r.json().then((data) => {
                    this.setState({
                        item: data['catalog.position'],
                        loaded: true,
                        price: Number(data['catalog.position'].services[0].service_price) + Number(data['catalog.position'].services[0].material_price)
                    })
                })
        }).catch(r => console.log(r));
    }

    setServiceCount(event, type, position){
        let count = 0;
        if (event.target.value !== ''){
            if (/^[0-9]+$/.test(event.target.value)) {
                count = Number(event.target.value);
            }
        }
        switch (type) {
            case 0:{
                this.setItem(this.state.services, count);
                break;
            }
            case 1: {
                let services = this.state.services.filter(item =>{
                    return item.id !== position.id;
                });
                services.push({id: position.id, count: count, price: position.price});
                this.setItem(services, this.state.refund);
                break;
            }
        }
    }

    setItem(services,refund){
        if (!this.checkDelete(services, refund)) {
            this.props.addItem({id: this.props.id, services: services, price: this.state.price, refund: refund});
        }
        else
            this.props.deleteItem(this.props.id);
        this.setState({
            services: services,
            refund: refund
        })

    }

    buttonChangeValue(type, plus, position){
        let count = 0;
        switch (type) {
            case 0:{
                count = this.state.refund;
                if (plus)count++;
                else if (count >0) count--;
                this.setState({refund: count});
                this.setItem(this.state.services, count);
                break;
            }
            case 1:{
                let services = this.state.services.filter(item =>{
                    return item.id !== position.id;
                });
                count = position.count;
                if (plus)count++;
                else if (count >0) count--;
                services.push({id: position.id, count: count, price: position.price});
                this.setState({services: services});
                this.setItem(services, this.state.refund);
                break;
            }
        }
    }

    checkDelete(services, refund){
        let flag = true;
        services.forEach(item => {
            if (item.count !== 0)
                flag = false;
        });
        return flag && refund === 0;
    }

    clearItem(){
        this.props.deleteItem(this.props.id);
        this.setState({
            services: [],
            refund: 0
        })
    }

    render(){
        const {catalog, cart} = this.props;
        let price = 0;
        let count = 0;
        this.state.services.forEach(item=>{
            price += item.count * item.price;
            count += item.count;
        });
        let head_count = 0;
        this.props.cart.cart_items.map(element => {
            if (Number(element.id) === Number(this.props.id)){
                element.services.map(service =>{
                        head_count += service.count;
                })
            }
        });
        return(
            <div>
                    <MuiAccordion
                        square
                        className={'catalog_item'}
                        expanded={this.props.index === catalog.visible_position}
                    >
                        <MuiAccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id={"panel1a-header-"+this.props.index}
                            onClick={() => {
                                if (catalog.visible_position !== this.props.index)
                                    this.props.setVisiblePosition(this.props.index)
                                else
                                    this.props.setVisiblePosition(-1)
                            }}
                            onMouseOut={e => {
                                document.getElementById("panel1a-header-"+this.props.index).style.height=38+'px';
                            }}
                        >
                            <div className={'catalog_item_header'}>
                                <div className={'catalog_item_header_info'} >
                                    <div>
                                        <div className={'catalog_qr'} onMouseOver={e => {
                                            document.getElementById("panel1a-header-"+this.props.index).style.height= document.getElementById('catalog_qr_description-' + this.props.index).offsetHeight+'px';
                                        }}>
                                            {code}
                                            <div id={'catalog_qr_description-' + this.props.index} className={'catalog_qr_description'}>{this.props.description}</div>
                                        </div>
                                        {/*<img src={QR} className={'catalog_qr'} alt={''}/>*/}
                                        <p>{this.state.item.name}</p>
                                    </div>
                                    <div>
                                        <p><span>₽</span> {this.state.price.toFixed(2)}</p>
                                        <p>{(price).toFixed(2)}</p>
                                        <p>{head_count} <span>шт.</span></p>
                                    </div>
                                </div>
                            </div>
                        </MuiAccordionSummary>
                        <MuiAccordionDetails>
                            <div style={{width: '100%', borderBottom: '1px dotted black'}}>
                                {this.state.loaded?(
                                <div>
                                    {this.state.item.services.map((item, index) => {
                                        let position;
                                        let count = 0;
                                        try {
                                            position = this.state.services.filter(el => {
                                                return Number(el.id) === Number(item.catalog_service_id)
                                            })[0];
                                            if (position === undefined) {
                                                cart.cart_items.map(element => {
                                                    if (Number(element.id) === Number(this.state.id)){
                                                        element.services.map(service =>{
                                                            count += service.count;
                                                        })
                                                    }
                                                });
                                                position = {
                                                    id: item.catalog_service_id,
                                                    count: count,
                                                    price: Number(item.service_price) + Number(item.material_price)
                                                }
                                            }
                                        }catch (e) {
                                            console.log(e)
                                            position = {id: item.catalog_service_id, count: 0, price: Number(item.service_price) + Number(item.material_price)}
                                        }
                                        return(
                                            ServicePosition(position.count, 1, item.service_name, Number(item.service_price)+Number(item.material_price), this.buttonChangeValue, this.setServiceCount, position)
                                        )
                                    })}
                                    {ServicePosition(this.state.refund, 0, 'Возврат отработанных картриджей', '', this.buttonChangeValue, this.setServiceCount)}
                                    <div className={"catalog_description_button"}>
                                        <button className={'favorites'}>
                                            <p>В избранное</p>
                                            {HearthIcon()}
                                        </button>
                                        <button onClick={() => this.clearItem()} className={'delete'} >
                                            <p>Удалить</p>
                                        </button>
                                    </div>
                                </div>
                                ): undefined}
                            </div>
                        </MuiAccordionDetails>
                    </MuiAccordion>
            </div>
        )
    }

}
const mapStateToProps = store => {
    return{
        cart: store.cart,
        catalog: store.catalog
    }
};

const mapDispatchToProps = dispatch => {
    return{
        deleteItem: (id) => dispatch(deleteItem(id)),
        addItem: (id) => dispatch(addItem(id)),
        setVisiblePosition: (index) => dispatch(setVisiblePosition(index))
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(CatalogItem);
